export class User {
    username: string;
    email: string;
    kcId: string;
    emailVerified: boolean;
    disabled: boolean;
}
